import { Page } from '../interfaces/page';

export const emptyPage: Page<any> = { page: [], totalCount: 0 };
